export const EXTERNAL_LINKS = {
  gameplay: 'https://docs.google.com/presentation/d/1ZNYFvmrOeQVyzrUcmemeJScCX7-8bmIt',
  video: 'https://www.youtube.com/embed/IzchEE3W3Ok',
  browser: 'https://play.paradisetycoon.com',
  google: 'https://play.google.com/store/apps/details?id=games.empires.paradisetycoon',
  appstore: 'https://testflight.apple.com/join/sQ1hbXvC',
  paradiseChain: 'https://docsend.com/view/qkasv94f4rcqbjdd',
  roadmap: 'https://paradisetycoon.medium.com/paradise-ahead-looking-back-at-an-incredible-year-and-what-comes-next-452f6012e731',
  creator: 'https://paradisetycoon.medium.com/the-creator-update-is-here-b8dc3391573a',
  paradisePass: 'https://sphere.market/immutable/collection/0xAFc652a4Fba298080B321f6bCb44C230C95Ff939',
  paradiseTools: 'https://sphere.market/immutable/collection/0xb83EcD0624B433DE49f89a004bB67315D87c99cE',
  paradiseCloud: 'https://paradise.cloud',
  twitter: 'https://twitter.com/paradisetycoon',
  facebook: 'https://www.facebook.com/paradisetycoon',
  telegram: 'https://t.me/paradisetycoon',
  medium: 'https://paradisetycoon.medium.com/',
  discord: 'https://discord.gg/NF3SK67C7C',
  tiktok: 'https://www.tiktok.com/@paradisetycoon',
  twitch: 'https://twitch.com/empiresnotvampires/',
  team: 'https://empires.games'
}; 